import { Fragment, useState } from "react";
import ModalForForm from "../Components/Modals/ModalForForm";
import ModalConfirmation from "../Components/Modals/ModalConfirmation";
import UserList from "../Components/Users/UserList";

const UserPage = () => {
  const dummyData = [
    {
      id: "1",
      userid: "test.png",
      username: "Title",
      usertype: "Text",
    },
    {
      id: "2",
      userid: "test.png 2",
      username: "Title 2",
      usertype: "Text 2",
    },
    {
      id: "3",
      userid: "test.png 3",
      username: "Title 3",
      usertype: "Text 3",
    },
  ];

  const [userIDToUpdate, setUserIDToUpdate] = useState("");
  const [userList, setUserList] = useState(dummyData);
  // setUserList(dummyData);

  const addUserHandler = (user) => {
    console.log("add user: " + user);
    // save to database.

    // add in list
    setUserList((prevUserList) => {
      return [user, ...prevUserList];
    });
  };

  return (
    <Fragment>
      {/* <ModalForForm></ModalForForm> */}
      {/* <ModalConfirmation ></ModalConfirmation> */}
      {/* user page...
      <UserList userList={userList} /> */}
    </Fragment>
  );
};

export default UserPage;
